<template>
  <div>
    <slot></slot>
  </div>
</template>

<script lang="ts">
  import Vue from "vue";
  import actionBaseMixin from "../mixins/action-base-mixin";
  import ObjectModelAction from "../../../common/models/objectModelActions/objectModelAction";

  export default Vue.extend({
    mixins: [
      actionBaseMixin
    ],
    props: {
      objectModelAction: {
        type: Object as () => ObjectModelAction,
        default: null,
      },
    },
    data: function() {
      return {
      };
    },
  });
</script>